<template>
  <div class="vstorage-cost-upthere-container">
    <div class="vstorage-cost-upthere-header">Storage plan</div>

    <div class="vstorage-cost-upthere-plans">
      <div class="vstorage-cost-upthere-plan current">
        <div
          class="vstorage-cost-upthere-plan-bytes"
          v-html="$options.filters.angularFilter(component.size, 'bytesHtml')"
        ></div>
        <div
          class="vstorage-cost-upthere-plan-limit"
          v-html="$options.filters.angularFilter(plan.limit, 'bytesHtml')"
        ></div>

        <f-progress-bar
          class="vstorage-cost-upthere-plan-progressbar"
          :progress="component.size / plan.limit"
        ></f-progress-bar>

        <div class="vstorage-cost-upthere-plan-cost" v-if="plan.cost == 0">
          free
        </div>
        <div class="vstorage-cost-upthere-plan-cost" v-if="plan.cost > 0">
          {{ plan.cost }} credits/month
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["component", "handler"],
  computed: {
    plan() {
      return (
        this.component?.plans?.[this.component?.plan_nid] ??
        this.component?.plans?.[Object.keys(this.component?.plans)[0]]
      );
    },
  },
};
</script>

<style lang="scss">
.vstorage-cost-upthere-container {
  border: 1px solid var(--white-a25);
  border-radius: 8px;

  .vstorage-cost-upthere-header {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 6px;
    padding: 8px;
  }
  .vstorage-cost-upthere-plan {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto;
    column-gap: 8px;
    row-gap: 8px;
    padding: 8px;
  }

  .vstorage-cost-upthere-plan.not-current {
    background-color: var(--primary);
    row-gap: 0;
  }

  .vstorage-cost-upthere-plan-bytes {
    grid-row: 1/2;
    grid-column: 1/2;
  }

  .vstorage-cost-upthere-plan-limit {
    grid-row: 1/2;
    grid-column: 3/4;
    font-weight: 700;
  }

  .current .vstorage-cost-upthere-plan-limit {
    justify-self: end;
  }

  .not-current .vstorage-cost-upthere-plan-limit {
    grid-row: 1/2;
    grid-column: 1/2;
    color: rgba(22, 22, 21, 0.5);
    justify-self: start;
  }

  .vstorage-cost-upthere-plan-progressbar {
    grid-row: 2/3;
    grid-column: 1/4;
  }

  .vstorage-cost-upthere-plan-cost {
    grid-row: 3/4;
    grid-column: 3/4;
    background-color: var(--primary);
    padding: 4px 8px;
    border-radius: 4px;
    color: var(--black);
    font-weight: 700;
    white-space: nowrap;
  }

  .current .vstorage-cost-upthere-plan-cost {
    justify-self: end;
  }

  .not-current .vstorage-cost-upthere-plan-cost {
    color: var(--primary);
    grid-row: 2/3;
    grid-column: 1/2;
    background: none;
    padding: 0;
    font-weight: 500;
    justify-left: start;
  }
}
</style>